<template>
    <CommonBox title="Recommend Marketing Materials" @close="$emit('close')" @submit="submit">
        <el-form ref="form" label-width="150px" :model="initForm" :rules="rules">

        <el-form-item label="Company" prop="Companys">
                <el-select style="width:90%; " v-model="initForm.Companys" placeholder="">
                    <el-option
                        v-for="item in companysList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>
        </el-form-item>
        
        <el-form-item label="Products" prop="Products">
                <el-select style="width:90%; " v-model="initForm.Products" placeholder="">
                    <el-option
                        v-for="item in productsList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>
        </el-form-item>

        <el-form-item label="Solutions" prop="Solutions">
                <el-select style="width:90%; " v-model="initForm.Solutions" placeholder="">
                    <el-option
                        v-for="item in solutionsList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>
        </el-form-item>

         <el-form-item label="Exhibitions" prop="Exhibitions">
                <el-select style="width:90%; " v-model="initForm.Exhibitions" placeholder="">
                    <el-option
                        v-for="item in exhibitionsList"
                        :key="item.ID"
                        :label="item.Name"
                        :value="item.ID">
                    </el-option>
                </el-select>
        </el-form-item>

        </el-form>
    </CommonBox>
</template>

<script>
import CommonBox from "@/components/common/CommonBox.vue";
export default {
    components:{
        CommonBox
    },
    props:{
        initForm:{
        }
    },
    data () {
        return {
            rules:{
                Companys:[{required: true, message: 'Please select a company file', trigger: 'blur'}],
                Products:[{required: true, message: 'Please select a products file', trigger: 'blur'}],
                Solutions:[{required: true, message: 'Please select a solutions file', trigger: 'blur'}],
                Exhibitions:[{required: true, message: 'Please select a exhibitions file', trigger: 'blur'}]
            },
            companysList:[],
            solutionsList:[],
            productsList:[],
            exhibitionsList:[]
        };
    },
    mounted () {
        this.getProducts();
        this.getSolutions();
        this.getCompanys();
        this.getExhibitions();
    },
    methods:{
        getProducts () {
            this.$http.get("getProducts",{},(data)=>{
                this.productsList = data.data;
            });
        },
        getSolutions () {
            this.$http.get("getSolutions",{},(data)=>{
                this.solutionsList = data.data;
            });
        },
        getCompanys () {
            this.$http.get("getCompanys",{},(data)=>{
                this.companysList = data.data;
            });
        },
        getExhibitions () {
            this.$http.get("getExhibitions",{},(data)=>{
                this.exhibitionsList = data.data;
            });
        },
        submit () {
            this.$refs.form.validate((valid) => {
                if(!valid) return false;
                let form = Object.assign({},this.initForm);
                let methods = 'put';
                let url = 'setPartnerRecommend';
                this.$http[methods](url,form,(data)=>{
                    this.$baseNotice.message(data.msg);
                    this.$emit('close');
                    this.$emit('update');
                });
            });
        }
    }
};
</script>
